import {useUiFlag} from "state/hooks";

export default function useSelectedDevices() {
    const localStorageDevices = localStorage.getItem('mediaDevices');
    return useUiFlag('mediaDevices', localStorageDevices ? JSON.parse(localStorageDevices) : {});
}